import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import CrearSede from "../Sedes/CreaSede";
import { obtenerSedes, sedesPorInstitucionId } from "../../Services/Rest";
import Cookies from "universal-cookie";
import EditarSede from "./EditarSede";

function InfoSedes(props) {
  const cookies = new Cookies();
  const urlA = obtenerSedes;
  const urlU = sedesPorInstitucionId;
  const cookie = new Cookies();

  if (cookie.get("tipo_Usuario") == 1) {
    var urlendpoint = urlU + props.idInstitucion;
  }
  if (cookie.get("tipo_Usuario") == 2) {
    var urlendpoint = urlU + cookie.get("institucionid");
  }
  if (cookie.get("tipo_Usuario") == 3) {
    var urlendpoint = urlU + props.idInstitucion;
  }
  if (cookie.get("tipo_Usuario") == 4) var urlendpoint = urlA;
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      url: urlendpoint,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  const [postEstado, setPostEstado] = useState([]);
  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtenerInstituciones",
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);
  const BusacarPorEstado = () => {
    axios
      .get(sedesPorInstitucionId + postEstado)
      .then((response) => {
        setList(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handlecountry = (event) => {
    const EStadoId = event.target.value;
    setPostEstado(EStadoId);
  };
  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Información Sedes
                </h6>
              </div>
              <div class="card-body">
                {cookie.get("tipo_Usuario") == 1 ? (
                  <form>
                    <select
                      className="btn btn-secondary btn-user btn-block text-left"
                      onChange={(e) => handlecountry(e)}
                    >
                      <option value="0">Seleccione </option>

                      {list1.map((getcon, index) => (
                        <option key={index} value={getcon.id}>
                          {getcon.razon_Social}{" "}
                        </option>
                      ))}
                    </select>

                    <button
                      className="btn btn-primary btn-user btn-block"
                      onClick={() => BusacarPorEstado()}
                    >
                      buscar
                    </button>
                    <hr />
                  </form>
                ) : (
                  <h1></h1>
                )}
                {cookies.get("tipo_Usuario") == 2 ? <CrearSede /> : <h></h>}

                <hr />
                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Nombre Sede</th>
                        <th>Direccion</th>
                        <th>Persona de contacto</th>
                        <th>Numero de Contacto</th>
                        <th>Fecha Acreditacion</th>
                        <th>Fecha Renovacion</th>
                        <th>Codigo Prestador</th>
                        <th>Status</th>
                        {cookie.get("tipo_Usuario") == 2 ? (
                          <th>Editar</th>
                        ) : (
                          <h1></h1>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item) => {
                        return (
                          <tr>
                            <td>{item.nombre}</td>
                            <td>{item.direccion}</td>
                            <td>{item.nombreContacto}</td>
                            <td>{item.numeroContacto}</td>
                            <td>{item.fechaAcreditacion}</td>
                            <td>{item.fechaRenovacion}</td>
                            <td>{item.codigoPrestadorSede}</td>
                            <td>{item.especialidad}</td>
                            {cookie.get("tipo_Usuario") == 2 ? (
                              <td>
                                <EditarSede
                                  idSede={item.id}
                                  nombre={item.nombre}
                                  direccion={item.direccion}
                                  nombreContacto={item.nombreContacto}
                                  numeroContacto={item.numeroContacto}
                                  codigoPrestadorSede={item.codigoPrestadorSede}
                                />
                              </td>
                            ) : (
                              <h1></h1>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default InfoSedes;
